import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

////////////////////////////////////////////////////////////////////////////
import { HTTPRequestService } from './services/httpRequest.service';
import { UploadService } from './services/upload.service';
import { AuthService } from './services/auth.service';
import { UIModule } from './ui/ui.module';
////////////////////////////////////////////////////////////////////////////
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { LangInterceptor } from './interceptor/lang.interceptor';
import { FirebaseModule } from './modules/firebase.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JabilComponent } from './unauthenticated/okta/jabil/jabil.component';

///////////////////////////////////////////////////////////////////
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTAService } from './unauthenticated/okta/services/okta.service';
import { LocalStorage } from './misc/localStorage';
import { LocalStorageEnum } from './misc/enums';
///////////////////////////////////////////////////////////////////

const access = (type: 'akibaOKTALocal' | 'akibaOKTADev' | 'oktaJabilDev' | 'oktaJabilProd' | 'akibaOKTAProd'): any => {

  switch (type) {
    case 'akibaOKTALocal':
      return environment.akibaOKTALocal;
    case 'akibaOKTADev':
      return environment.akibaOKTADev;
    case 'oktaJabilDev':
      return environment.oktaJabilDev;
    case 'oktaJabilProd':
      return environment.oktaJabilProd;
    case 'akibaOKTAProd':
      return environment.akibaOKTAProd;
    default:
      return environment.akibaOKTALocal;
  }

}

const oktaCredentials = access('oktaJabilProd');

const oktaAuth = new OktaAuth({
  issuer: oktaCredentials.authority,
  clientId: oktaCredentials.clientId,
  redirectUri: oktaCredentials.redirectUri,
  postLogoutRedirectUri: oktaCredentials.postLogoutRedirectUri
});

LocalStorage.saveToStorage(LocalStorageEnum.CompanySSOInfo, oktaCredentials);

////////////////////////////////////////////////////////////////////////////

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    JabilComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es-mx',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false
    }),
    FirebaseModule,
    HttpClientModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    UIModule,
    OktaAuthModule,
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LangInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    HTTPRequestService,
    UploadService,
    AuthService,
    OKTAService,
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth }
    },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
